"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.5.4'] && _();
}
catch (e) { }
